import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import '@adornis/digitale-helden-shared/client/components/component-icon-button.js';
import '@adornis/digitale-helden-shared/client/theme/d-checkbox';
import '@adornis/digitale-helden-shared/client/theme/d-input';
import { BaseMarketingTopbarLink } from '../../db/links/BaseMarketingTopbarLink';
import { MarketingLinkExtension } from './MarketingLinkExtension';

export const MarketingTopbarLinkExtension: BuildifyExtension<BaseMarketingTopbarLink> = {
  ...MarketingLinkExtension,
  class: BaseMarketingTopbarLink,
};
